export default __webpack_public_path__ + "static/media/silver.fa929154.mp3";